/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequest,
  BulkUpdateOrderInfo200Response,
  BulkUpdateOrderInfoRequest,
  DuplicateData,
  GetOrderDetail200Response,
  GetOrderMemo200Response,
  GetOrderMessages200ResponseInner,
  InternalServerError,
  NotFound,
  OrderPaginationResponse,
  PutOrderMemo200Response,
  PutOrderMemoRequest,
  ServiceUnavailable,
  Unauthorized,
  UnprocessableEntity,
  UpdateOrderInfo200Response,
  UpdateOrderInfoRequest,
} from '../models/index';
import {
    BadRequestFromJSON,
    BadRequestToJSON,
    BulkUpdateOrderInfo200ResponseFromJSON,
    BulkUpdateOrderInfo200ResponseToJSON,
    BulkUpdateOrderInfoRequestFromJSON,
    BulkUpdateOrderInfoRequestToJSON,
    DuplicateDataFromJSON,
    DuplicateDataToJSON,
    GetOrderDetail200ResponseFromJSON,
    GetOrderDetail200ResponseToJSON,
    GetOrderMemo200ResponseFromJSON,
    GetOrderMemo200ResponseToJSON,
    GetOrderMessages200ResponseInnerFromJSON,
    GetOrderMessages200ResponseInnerToJSON,
    InternalServerErrorFromJSON,
    InternalServerErrorToJSON,
    NotFoundFromJSON,
    NotFoundToJSON,
    OrderPaginationResponseFromJSON,
    OrderPaginationResponseToJSON,
    PutOrderMemo200ResponseFromJSON,
    PutOrderMemo200ResponseToJSON,
    PutOrderMemoRequestFromJSON,
    PutOrderMemoRequestToJSON,
    ServiceUnavailableFromJSON,
    ServiceUnavailableToJSON,
    UnauthorizedFromJSON,
    UnauthorizedToJSON,
    UnprocessableEntityFromJSON,
    UnprocessableEntityToJSON,
    UpdateOrderInfo200ResponseFromJSON,
    UpdateOrderInfo200ResponseToJSON,
    UpdateOrderInfoRequestFromJSON,
    UpdateOrderInfoRequestToJSON,
} from '../models/index';

export interface BulkUpdateOrderInfoOperationRequest {
    bulkUpdateOrderInfoRequest: BulkUpdateOrderInfoRequest;
}

export interface DeleteOrderMemoRequest {
    ifMatch: number;
    orderNo: string;
}

export interface ExportOrdersCsvRequest {
    sort?: ExportOrdersCsvSortEnum;
    passengerName?: string;
    passengerTel?: string;
    radioNo?: string;
    orderNo?: string;
    driverName?: string;
    orderDateFrom?: string;
    orderDateTo?: string;
    orderStatuses?: Array<string>;
    carDispatchStatus?: ExportOrdersCsvCarDispatchStatusEnum;
    companyName?: string;
    subCompanyName?: string;
    salesCompanyName?: string;
    orderType?: ExportOrdersCsvOrderTypeEnum;
    paymentMethod?: ExportOrdersCsvPaymentMethodEnum;
    settlementType?: string;
}

export interface GetOrderDetailRequest {
    orderNo: string;
}

export interface GetOrderMemoRequest {
    orderNo: string;
}

export interface GetOrderMessagesRequest {
    orderNo: string;
    sort?: GetOrderMessagesSortEnum;
}

export interface GetOrderPdfRequest {
    orderNo: string;
}

export interface GetOrdersRequest {
    page?: number;
    count?: number;
    sort?: GetOrdersSortEnum;
    passengerName?: string;
    passengerTel?: string;
    radioNo?: string;
    orderNo?: string;
    driverName?: string;
    orderDateFrom?: string;
    orderDateTo?: string;
    orderStatuses?: Array<string>;
    carDispatchStatus?: GetOrdersCarDispatchStatusEnum;
    companyName?: string;
    subCompanyName?: string;
    salesCompanyName?: string;
    orderType?: GetOrdersOrderTypeEnum;
    paymentMethod?: GetOrdersPaymentMethodEnum;
    settlementType?: string;
}

export interface PutOrderMemoOperationRequest {
    ifMatch: number;
    orderNo: string;
    putOrderMemoRequest: PutOrderMemoRequest;
}

export interface UpdateOrderInfoOperationRequest {
    orderNo: string;
    updateOrderInfoRequest: UpdateOrderInfoRequest;
}

/**
 * 
 */
export class OrdersApi extends runtime.BaseAPI {

    /**
     * 本APIは、複数の注文情報を一括で更新します。 1回のリクエストで最大1000件の注文を更新できます。 
     * 注文の一括更新
     */
    async bulkUpdateOrderInfoRaw(requestParameters: BulkUpdateOrderInfoOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkUpdateOrderInfo200Response>> {
        if (requestParameters['bulkUpdateOrderInfoRequest'] == null) {
            throw new runtime.RequiredError(
                'bulkUpdateOrderInfoRequest',
                'Required parameter "bulkUpdateOrderInfoRequest" was null or undefined when calling bulkUpdateOrderInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/orders`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BulkUpdateOrderInfoRequestToJSON(requestParameters['bulkUpdateOrderInfoRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkUpdateOrderInfo200ResponseFromJSON(jsonValue));
    }

    /**
     * 本APIは、複数の注文情報を一括で更新します。 1回のリクエストで最大1000件の注文を更新できます。 
     * 注文の一括更新
     */
    async bulkUpdateOrderInfo(requestParameters: BulkUpdateOrderInfoOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkUpdateOrderInfo200Response> {
        const response = await this.bulkUpdateOrderInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 注文メモの削除
     */
    async deleteOrderMemoRaw(requestParameters: DeleteOrderMemoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PutOrderMemo200Response>> {
        if (requestParameters['ifMatch'] == null) {
            throw new runtime.RequiredError(
                'ifMatch',
                'Required parameter "ifMatch" was null or undefined when calling deleteOrderMemo().'
            );
        }

        if (requestParameters['orderNo'] == null) {
            throw new runtime.RequiredError(
                'orderNo',
                'Required parameter "orderNo" was null or undefined when calling deleteOrderMemo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifMatch'] != null) {
            headerParameters['If-Match'] = String(requestParameters['ifMatch']);
        }


        let urlPath = `/orders/{order_no}/memo`;
        urlPath = urlPath.replace(`{${"order_no"}}`, encodeURIComponent(String(requestParameters['orderNo'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PutOrderMemo200ResponseFromJSON(jsonValue));
    }

    /**
     * 注文メモの削除
     */
    async deleteOrderMemo(requestParameters: DeleteOrderMemoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PutOrderMemo200Response> {
        const response = await this.deleteOrderMemoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 本APIは、検索条件に一致する注文一覧情報をCSV形式でダウンロードします。<br><br>  **CSVファイルのエンコーディングについて**<br> - 本APIが返すCSVファイルは、`Shift_JIS` でエンコードされています。<br>  **Swagger UI からのダウンロード時の注意点**<br> - Swagger UI 経由でCSVファイルをダウンロードした場合、**UTF-8として保存され、文字化けします。**<br> - この場合、curlコマンドなどを使用して直接ファイルをダウンロードしてください。<br><br>  curl 例：<br> <code>curl -o orders.csv \"http://localhost:8080/order/orders/csv?sort=desc\" -H \"accept: text/csv\"</code> 
     * 注文一覧CSVのダウンロード
     */
    async exportOrdersCsvRaw(requestParameters: ExportOrdersCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['passengerName'] != null) {
            queryParameters['passenger_name'] = requestParameters['passengerName'];
        }

        if (requestParameters['passengerTel'] != null) {
            queryParameters['passenger_tel'] = requestParameters['passengerTel'];
        }

        if (requestParameters['radioNo'] != null) {
            queryParameters['radio_no'] = requestParameters['radioNo'];
        }

        if (requestParameters['orderNo'] != null) {
            queryParameters['order_no'] = requestParameters['orderNo'];
        }

        if (requestParameters['driverName'] != null) {
            queryParameters['driver_name'] = requestParameters['driverName'];
        }

        if (requestParameters['orderDateFrom'] != null) {
            queryParameters['order_date_from'] = requestParameters['orderDateFrom'];
        }

        if (requestParameters['orderDateTo'] != null) {
            queryParameters['order_date_to'] = requestParameters['orderDateTo'];
        }

        if (requestParameters['orderStatuses'] != null) {
            queryParameters['order_statuses'] = requestParameters['orderStatuses'];
        }

        if (requestParameters['carDispatchStatus'] != null) {
            queryParameters['car_dispatch_status'] = requestParameters['carDispatchStatus'];
        }

        if (requestParameters['companyName'] != null) {
            queryParameters['company_name'] = requestParameters['companyName'];
        }

        if (requestParameters['subCompanyName'] != null) {
            queryParameters['sub_company_name'] = requestParameters['subCompanyName'];
        }

        if (requestParameters['salesCompanyName'] != null) {
            queryParameters['sales_company_name'] = requestParameters['salesCompanyName'];
        }

        if (requestParameters['orderType'] != null) {
            queryParameters['order_type'] = requestParameters['orderType'];
        }

        if (requestParameters['paymentMethod'] != null) {
            queryParameters['payment_method'] = requestParameters['paymentMethod'];
        }

        if (requestParameters['settlementType'] != null) {
            queryParameters['settlement_type'] = requestParameters['settlementType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/orders/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * 本APIは、検索条件に一致する注文一覧情報をCSV形式でダウンロードします。<br><br>  **CSVファイルのエンコーディングについて**<br> - 本APIが返すCSVファイルは、`Shift_JIS` でエンコードされています。<br>  **Swagger UI からのダウンロード時の注意点**<br> - Swagger UI 経由でCSVファイルをダウンロードした場合、**UTF-8として保存され、文字化けします。**<br> - この場合、curlコマンドなどを使用して直接ファイルをダウンロードしてください。<br><br>  curl 例：<br> <code>curl -o orders.csv \"http://localhost:8080/order/orders/csv?sort=desc\" -H \"accept: text/csv\"</code> 
     * 注文一覧CSVのダウンロード
     */
    async exportOrdersCsv(requestParameters: ExportOrdersCsvRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.exportOrdersCsvRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 注文詳細を取得
     */
    async getOrderDetailRaw(requestParameters: GetOrderDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOrderDetail200Response>> {
        if (requestParameters['orderNo'] == null) {
            throw new runtime.RequiredError(
                'orderNo',
                'Required parameter "orderNo" was null or undefined when calling getOrderDetail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/orders/{order_no}`;
        urlPath = urlPath.replace(`{${"order_no"}}`, encodeURIComponent(String(requestParameters['orderNo'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOrderDetail200ResponseFromJSON(jsonValue));
    }

    /**
     * 注文詳細を取得
     */
    async getOrderDetail(requestParameters: GetOrderDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOrderDetail200Response> {
        const response = await this.getOrderDetailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 注文メモの取得
     */
    async getOrderMemoRaw(requestParameters: GetOrderMemoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOrderMemo200Response>> {
        if (requestParameters['orderNo'] == null) {
            throw new runtime.RequiredError(
                'orderNo',
                'Required parameter "orderNo" was null or undefined when calling getOrderMemo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/orders/{order_no}/memo`;
        urlPath = urlPath.replace(`{${"order_no"}}`, encodeURIComponent(String(requestParameters['orderNo'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOrderMemo200ResponseFromJSON(jsonValue));
    }

    /**
     * 注文メモの取得
     */
    async getOrderMemo(requestParameters: GetOrderMemoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOrderMemo200Response> {
        const response = await this.getOrderMemoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 注文に紐づくメッセージ一覧の取得
     */
    async getOrderMessagesRaw(requestParameters: GetOrderMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetOrderMessages200ResponseInner>>> {
        if (requestParameters['orderNo'] == null) {
            throw new runtime.RequiredError(
                'orderNo',
                'Required parameter "orderNo" was null or undefined when calling getOrderMessages().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/orders/{order_no}/messages`;
        urlPath = urlPath.replace(`{${"order_no"}}`, encodeURIComponent(String(requestParameters['orderNo'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetOrderMessages200ResponseInnerFromJSON));
    }

    /**
     * 注文に紐づくメッセージ一覧の取得
     */
    async getOrderMessages(requestParameters: GetOrderMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetOrderMessages200ResponseInner>> {
        const response = await this.getOrderMessagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 注文詳細PDFのダウンロード
     */
    async getOrderPdfRaw(requestParameters: GetOrderPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['orderNo'] == null) {
            throw new runtime.RequiredError(
                'orderNo',
                'Required parameter "orderNo" was null or undefined when calling getOrderPdf().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/orders/{order_no}/pdf`;
        urlPath = urlPath.replace(`{${"order_no"}}`, encodeURIComponent(String(requestParameters['orderNo'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * 注文詳細PDFのダウンロード
     */
    async getOrderPdf(requestParameters: GetOrderPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getOrderPdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 注文一覧情報取得
     */
    async getOrdersRaw(requestParameters: GetOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderPaginationResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['passengerName'] != null) {
            queryParameters['passenger_name'] = requestParameters['passengerName'];
        }

        if (requestParameters['passengerTel'] != null) {
            queryParameters['passenger_tel'] = requestParameters['passengerTel'];
        }

        if (requestParameters['radioNo'] != null) {
            queryParameters['radio_no'] = requestParameters['radioNo'];
        }

        if (requestParameters['orderNo'] != null) {
            queryParameters['order_no'] = requestParameters['orderNo'];
        }

        if (requestParameters['driverName'] != null) {
            queryParameters['driver_name'] = requestParameters['driverName'];
        }

        if (requestParameters['orderDateFrom'] != null) {
            queryParameters['order_date_from'] = requestParameters['orderDateFrom'];
        }

        if (requestParameters['orderDateTo'] != null) {
            queryParameters['order_date_to'] = requestParameters['orderDateTo'];
        }

        if (requestParameters['orderStatuses'] != null) {
            queryParameters['order_statuses'] = requestParameters['orderStatuses'];
        }

        if (requestParameters['carDispatchStatus'] != null) {
            queryParameters['car_dispatch_status'] = requestParameters['carDispatchStatus'];
        }

        if (requestParameters['companyName'] != null) {
            queryParameters['company_name'] = requestParameters['companyName'];
        }

        if (requestParameters['subCompanyName'] != null) {
            queryParameters['sub_company_name'] = requestParameters['subCompanyName'];
        }

        if (requestParameters['salesCompanyName'] != null) {
            queryParameters['sales_company_name'] = requestParameters['salesCompanyName'];
        }

        if (requestParameters['orderType'] != null) {
            queryParameters['order_type'] = requestParameters['orderType'];
        }

        if (requestParameters['paymentMethod'] != null) {
            queryParameters['payment_method'] = requestParameters['paymentMethod'];
        }

        if (requestParameters['settlementType'] != null) {
            queryParameters['settlement_type'] = requestParameters['settlementType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/orders`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderPaginationResponseFromJSON(jsonValue));
    }

    /**
     * 注文一覧情報取得
     */
    async getOrders(requestParameters: GetOrdersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderPaginationResponse> {
        const response = await this.getOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 注文メモの登録・更新
     */
    async putOrderMemoRaw(requestParameters: PutOrderMemoOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PutOrderMemo200Response>> {
        if (requestParameters['ifMatch'] == null) {
            throw new runtime.RequiredError(
                'ifMatch',
                'Required parameter "ifMatch" was null or undefined when calling putOrderMemo().'
            );
        }

        if (requestParameters['orderNo'] == null) {
            throw new runtime.RequiredError(
                'orderNo',
                'Required parameter "orderNo" was null or undefined when calling putOrderMemo().'
            );
        }

        if (requestParameters['putOrderMemoRequest'] == null) {
            throw new runtime.RequiredError(
                'putOrderMemoRequest',
                'Required parameter "putOrderMemoRequest" was null or undefined when calling putOrderMemo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['ifMatch'] != null) {
            headerParameters['If-Match'] = String(requestParameters['ifMatch']);
        }


        let urlPath = `/orders/{order_no}/memo`;
        urlPath = urlPath.replace(`{${"order_no"}}`, encodeURIComponent(String(requestParameters['orderNo'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PutOrderMemoRequestToJSON(requestParameters['putOrderMemoRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PutOrderMemo200ResponseFromJSON(jsonValue));
    }

    /**
     * 注文メモの登録・更新
     */
    async putOrderMemo(requestParameters: PutOrderMemoOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PutOrderMemo200Response> {
        const response = await this.putOrderMemoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 本APIは、指定された注文番号に紐づく注文情報を更新します。 
     * 注文の更新
     */
    async updateOrderInfoRaw(requestParameters: UpdateOrderInfoOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateOrderInfo200Response>> {
        if (requestParameters['orderNo'] == null) {
            throw new runtime.RequiredError(
                'orderNo',
                'Required parameter "orderNo" was null or undefined when calling updateOrderInfo().'
            );
        }

        if (requestParameters['updateOrderInfoRequest'] == null) {
            throw new runtime.RequiredError(
                'updateOrderInfoRequest',
                'Required parameter "updateOrderInfoRequest" was null or undefined when calling updateOrderInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/orders/{order_no}`;
        urlPath = urlPath.replace(`{${"order_no"}}`, encodeURIComponent(String(requestParameters['orderNo'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateOrderInfoRequestToJSON(requestParameters['updateOrderInfoRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateOrderInfo200ResponseFromJSON(jsonValue));
    }

    /**
     * 本APIは、指定された注文番号に紐づく注文情報を更新します。 
     * 注文の更新
     */
    async updateOrderInfo(requestParameters: UpdateOrderInfoOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateOrderInfo200Response> {
        const response = await this.updateOrderInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ExportOrdersCsvSortEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ExportOrdersCsvSortEnum = typeof ExportOrdersCsvSortEnum[keyof typeof ExportOrdersCsvSortEnum];
/**
 * @export
 */
export const ExportOrdersCsvCarDispatchStatusEnum = {
    _1: '1',
    _2: '2',
    _3: '3',
    _4: '4',
    _5: '5',
    _6: '6',
    _7: '7',
    _8: '8',
    _9: '9',
    _11: '11',
    _12: '12',
    _13: '13'
} as const;
export type ExportOrdersCsvCarDispatchStatusEnum = typeof ExportOrdersCsvCarDispatchStatusEnum[keyof typeof ExportOrdersCsvCarDispatchStatusEnum];
/**
 * @export
 */
export const ExportOrdersCsvOrderTypeEnum = {
    _01: '01',
    _02: '02'
} as const;
export type ExportOrdersCsvOrderTypeEnum = typeof ExportOrdersCsvOrderTypeEnum[keyof typeof ExportOrdersCsvOrderTypeEnum];
/**
 * @export
 */
export const ExportOrdersCsvPaymentMethodEnum = {
    _0: '0',
    _1: '1',
    _2: '2',
    _3: '3',
    _4: '4',
    _5: '5',
    _6: '6',
    _7: '7',
    _8: '8',
    _9: '9',
    _10: '10',
    _11: '11',
    _12: '12',
    _13: '13',
    _14: '14',
    _15: '15'
} as const;
export type ExportOrdersCsvPaymentMethodEnum = typeof ExportOrdersCsvPaymentMethodEnum[keyof typeof ExportOrdersCsvPaymentMethodEnum];
/**
 * @export
 */
export const GetOrderMessagesSortEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetOrderMessagesSortEnum = typeof GetOrderMessagesSortEnum[keyof typeof GetOrderMessagesSortEnum];
/**
 * @export
 */
export const GetOrdersSortEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetOrdersSortEnum = typeof GetOrdersSortEnum[keyof typeof GetOrdersSortEnum];
/**
 * @export
 */
export const GetOrdersCarDispatchStatusEnum = {
    _1: '1',
    _2: '2',
    _3: '3',
    _4: '4',
    _5: '5',
    _6: '6',
    _7: '7',
    _8: '8',
    _9: '9',
    _11: '11',
    _12: '12',
    _13: '13'
} as const;
export type GetOrdersCarDispatchStatusEnum = typeof GetOrdersCarDispatchStatusEnum[keyof typeof GetOrdersCarDispatchStatusEnum];
/**
 * @export
 */
export const GetOrdersOrderTypeEnum = {
    _01: '01',
    _02: '02'
} as const;
export type GetOrdersOrderTypeEnum = typeof GetOrdersOrderTypeEnum[keyof typeof GetOrdersOrderTypeEnum];
/**
 * @export
 */
export const GetOrdersPaymentMethodEnum = {
    _0: '0',
    _1: '1',
    _2: '2',
    _3: '3',
    _4: '4',
    _5: '5',
    _6: '6',
    _7: '7',
    _8: '8',
    _9: '9',
    _10: '10',
    _11: '11',
    _12: '12',
    _13: '13',
    _14: '14',
    _15: '15'
} as const;
export type GetOrdersPaymentMethodEnum = typeof GetOrdersPaymentMethodEnum[keyof typeof GetOrdersPaymentMethodEnum];
